import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FilterListIcon from '@mui/icons-material/FilterList';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/ManageSearch';
import SearchSubmitIcon from '@mui/icons-material/Search';
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import { Avatar, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, ListSubheader, Tooltip, Typography } from "@mui/material";
import AccordionSummary from '@mui/material/AccordionSummary';
import Badge from "@mui/material/Badge";
import FormControl from '@mui/material/FormControl';
import InputBase from "@mui/material/InputBase";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from "@mui/material/Paper";
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from 'tss-react/mui';
import { AuthContext } from "../../context/Auth/AuthContext";
import usePendingTicketsLogic from "../../hooks/usePendingTicketsLogic";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import CreateTicketModal from "../CreateTicketModal/index.js";
import PendingTicketsNextMode from "../PendingTicketsNextMode";
import TabPanel from "../TabPanel";
import TicketsList from "../TicketsList";
import TicketsQueueSelect from "../TicketsQueueSelect";
// icons 
import AddIcon from '@mui/icons-material/Add';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import InventoryIcon from '@mui/icons-material/Inventory';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import TicketsConnectionSelect from '../TicketsConnectionSelect';
import "./style.css";

const useStyles = makeStyles()((theme) => {
  return {
    tabsHeader: {
      flex: "none",
    },
    settingsIcon: {
      alignSelf: "center",
      marginLeft: "auto",
      padding: 8,
    },

    tab: {
      minWidth: 120,
      width: 120,
      margin: '0px !important'
    },

    ticketOptionsBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: '0px 5px'
    },

    searchInputWrapper: {
      flex: 1,
      display: "flex",
      borderRadius: 40,
      padding: '3px !important',
      marginRight: theme.spacing(1),
    },

    accordionSearchWrapper: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      borderRadius: '0px 10px 10px 0px',
      padding: '5px 15px',
      backgroundColor: theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : '#f5f5f5',
      border: 'none',
      boxShadow: 'none',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      '&:focus-within': {
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.15)'
          : '#e8e8e8',
        transform: 'translateY(-1px)',
        boxShadow: theme.palette.mode === 'dark'
          ? `0 0 0 2px ${theme.palette.primary.main}40, 0 4px 12px rgba(0, 0, 0, 0.3)`
          : `0 0 0 2px ${theme.palette.primary.main}40, 0 2px 8px rgba(0, 0, 0, 0.1)`,
      }
    },

    searchIcon: {
      color: theme.palette.mode === 'dark' ? '#999' : '#666',
      marginRight: 12,
      alignSelf: "center",
      fontSize: '22px',
      opacity: 0.7,
      transition: 'opacity 0.2s ease',

      '.accordionSearchWrapper:focus-within &': {
        opacity: 1,
        color: theme.palette.primary.main,
      }
    },

    searchInput: {
      flex: 1,
      border: "none",
      borderRadius: 30,
    },

    accordionSearchInput: {
      flex: 1,
      border: "none",
      fontSize: '14px',
      backgroundColor: 'transparent',
      outline: 'none',

      '& input': {
        padding: '2px 0',
        fontSize: '14px',
        color: theme.palette.text.primary,
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',

        '&::placeholder': {
          color: theme.palette.mode === 'dark' ? '#aaa' : '#888',
          opacity: 1,
        }
      }
    },

    ticketsOpenWrapper: {
      overflowY: "auto",
      overflowX: "hidden",
      width: "100%",
      height: "100%",
      minHeight: 0, // Necessário para Firefox com flexbox
      boxSizing: "border-box",
    },

    isTabClosed: {
      width: 0,
      height: 0,
    },

    tabTicketIndicator: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      width: '20px',
      height: '20px',
      borderRadius: "50%",
    },

    accordionSummaryContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%',
      margin: '0 !important',
      padding: '0',
    },

    searchContainer: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },

    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '5px'
    },

    actionIconButton: {
      padding: '10px',
      borderRadius: '50%',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      backgroundColor: 'transparent',
      border: `1px solid transparent`,

      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.04)',
        transform: 'scale(1.05)',
        border: `1px solid ${theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.2)'
          : 'rgba(0, 0, 0, 0.1)'}`,
      },

      '&.active': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        transform: 'scale(1.02)',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 2px 8px rgba(0, 0, 0, 0.4)'
          : '0 2px 8px rgba(0, 0, 0, 0.15)',

        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          transform: 'scale(1.08)',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 4px 12px rgba(0, 0, 0, 0.5)'
            : '0 4px 12px rgba(0, 0, 0, 0.2)',
        }
      }
    },

    userAvatar: {
      width: 32,
      height: 32,
      fontSize: '14px',
      border: `2px solid ${theme.palette.background.paper}`,
      boxShadow: theme.palette.mode === 'dark'
        ? '0 2px 4px rgba(0, 0, 0, 0.3)'
        : '0 1px 3px rgba(0, 0, 0, 0.12)',
    },

    selectedUserAvatar: {
      width: 24,
      height: 24,
      fontSize: '12px',
      border: `1px solid ${theme.palette.divider}`,
    },
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '0px',
}));

// CORRIGIDO: Funções para localStorage com tratamento de erro
const getInitialViewTags = () => {
  try {
    const savedViewTags = localStorage.getItem("viewTags");
    if (savedViewTags === null) {
      return false; // Valor padrão
    }
    const parsed = JSON.parse(savedViewTags);
    return typeof parsed === 'boolean' ? parsed : false;
  } catch (error) {
    console.error('Erro ao carregar viewTags do localStorage:', error);
    return false; // Valor padrão em caso de erro
  }
};

const getInitialViewConnections = () => {
  try {
    const savedViewConnections = localStorage.getItem("viewConnections");
    if (savedViewConnections === null) {
      return false; // Valor padrão
    }
    const parsed = JSON.parse(savedViewConnections);
    return typeof parsed === 'boolean' ? parsed : false;
  } catch (error) {
    console.error('Erro ao carregar viewConnections do localStorage:', error);
    return false; // Valor padrão em caso de erro
  }
};

const TicketsManager = () => {

  const { classes } = useStyles();
  const history = useHistory();
  const [searchParam, setSearchParam] = useState("");
  const [accordionSearchParam, setAccordionSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [ticketsListOpenLength, setTicketsListOpenLength] = useState(0);
  const [ticketsListArchivedLength, setTicketsListArchivedLength] = useState(0);
  const [ticketsListPendingLength, setTicketsListPendingLength] = useState(0);
  const [ticketsListClosedLength, setTicketsListClosedLength] = useState(0);

  // CORRIGIDO: Estados com valores iniciais do localStorage
  const [viewTags, setViewTags] = useState(() => getInitialViewTags());
  const [viewConnections, setViewConnections] = useState(() => getInitialViewConnections());

  // NOVO ESTADO ADICIONADO PARA PESQUISA DE USUÁRIOS
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const searchInputRef = useRef();
  const accordionSearchInputRef = useRef();
  const { user } = useContext(AuthContext);
  // user.queues pode chegar undefined em transições de estado (ex: socket de
  // user_status atualizando o objeto user com payload parcial). Acesso seguro
  // evita crash da tela inteira.
  const userQueueIds = (user?.queues || []).map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(() => {
    const queueIds = userQueueIds || [];
    return [...queueIds, 'no_queue'];
  });

  const [connections, setConnections] = useState([]);
  const [selectedConnectionIds, setSelectedConnectionIds] = useState([]);

  const [users, setUsers] = useState([]);
  const [expanded, setExpanded] = useState(false);
  // CORRIGIDO: Estado inicial como string para consistência
  const [userTickets, setUserTickets] = useState(user.id?.toString() ?? "");
  const showAllTickets = useRef(false);

  // Estado de filtro de categoria de usuário
  const [statusFilter, setStatusFilter] = useState('all');
  const [companyPeriods, setCompanyPeriods] = useState([]);
  const pendingTicketsLogic = usePendingTicketsLogic();
  // Admin/supervisor podem forçar visualização em lista mesmo quando o modo global é "next" — efêmero.
  const [pendingViewOverride, setPendingViewOverride] = useState(null);
  const effectivePendingLogic = pendingViewOverride || pendingTicketsLogic;
  const canOverridePendingView = user.profile === 'admin' || user.profile === 'supervisor';

  // Estados para ações em lote
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [confirmBatchModal, setConfirmBatchModal] = useState(false);
  const [batchAction, setBatchAction] = useState('');
  const [batchLoading, setBatchLoading] = useState(false);

  // CORRIGIDO: useEffects para localStorage com debounce
  useEffect(() => {
    try {
      localStorage.setItem("viewTags", JSON.stringify(viewTags));
      console.log('viewTags salvo no localStorage:', viewTags);
    } catch (error) {
      console.error('Erro ao salvar viewTags no localStorage:', error);
    }
  }, [viewTags]);

  useEffect(() => {
    try {
      localStorage.setItem("viewConnections", JSON.stringify(viewConnections));
      console.log('viewConnections salvo no localStorage:', viewConnections);
    } catch (error) {
      console.error('Erro ao salvar viewConnections no localStorage:', error);
    }
  }, [viewConnections]);

  // CORRIGIDO: Funções para alterar os estados com callbacks
  const handleToggleViewTags = useCallback((e) => {
    e.stopPropagation();
    setViewTags(prevState => {
      const newState = !prevState;
      console.log('Alterando viewTags de', prevState, 'para', newState);
      return newState;
    });
  }, []);

  const handleToggleViewConnections = useCallback((e) => {
    e.stopPropagation();
    setViewConnections(prevState => {
      const newState = !prevState;
      console.log('Alterando viewConnections de', prevState, 'para', newState);
      return newState;
    });
  }, []);

  // NOVAS FUNÇÕES ADICIONADAS PARA CONTROLE DA PESQUISA DE USUÁRIOS
  const handleUserSearchChange = (event) => {
    setUserSearchTerm(event.target.value);
  };

  const handleUserSearchKeyDown = (event) => {
    // Prevenir que certas teclas fechem o menu
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter') {
      event.stopPropagation();
    }
  };

  const handleUserSearchClick = (event) => {
    // Prevenir que cliques no campo de pesquisa fechem o menu
    event.stopPropagation();
  };

  // Calcular status de cada usuário a partir de dados já serializados (sem query extra)
  const usersWithStatus = useMemo(() => {
    if (!users?.length) return [];

    const todayDow = new Date().getDay();
    const todayDate = new Date().toISOString().split('T')[0];

    return users.map(usr => {
      let daysOff = [], extraDaysOff = [], userPeriods = [];
      try { daysOff = JSON.parse(usr.daysOff || '[]'); } catch { }
      try { extraDaysOff = JSON.parse(usr.extraDaysOff || '[]'); } catch { }
      try { userPeriods = JSON.parse(usr.period || '[]'); } catch { }

      if (daysOff.includes(todayDow) || extraDaysOff.includes(todayDate)) {
        return { ...usr, _status: 'dayoff' };
      }

      if (userPeriods.length > 0 && companyPeriods.length > 0) {
        const onShift = companyPeriods.some(p => userPeriods.includes(p));
        if (!onShift) return { ...usr, _status: 'offshift' };
      }

      return { ...usr, _status: 'active' };
    });
  }, [users, companyPeriods]);

  const statusCounts = useMemo(() => {
    const c = { active: 0, dayoff: 0, offshift: 0 };
    usersWithStatus.forEach(u => { if (u.id !== user.id) c[u._status]++; });
    return c;
  }, [usersWithStatus, user.id]);

  // FUNÇÃO PARA FILTRAR USUÁRIOS BASEADO NO TERMO DE PESQUISA E CATEGORIA
  const filteredUsers = usersWithStatus
    ?.filter(usr => usr.id !== user.id)
    ?.filter(usr => statusFilter === 'all' || usr._status === statusFilter)
    ?.filter(usr =>
      !userSearchTerm || usr.name.toLowerCase().includes(userSearchTerm.toLowerCase())
    )
    ?.sort((a, b) => a.name.localeCompare(b.name)) || [];

  // Funções para ações em lote
  const handleBatchAction = (action) => {
    setBatchAction(action);
    setConfirmBatchModal(true);
  };

  const handleConfirmBatchAction = async () => {
    setBatchLoading(true);
    try {
      const status = batchAction === 'pending' ? 'pending' : 'closed';

      const response = await api.put('/tickets-batch-update', {
        ticketIds: selectedTickets,
        status: status,
        userId: user.id
      });

      setSelectedTickets([]);
      setConfirmBatchModal(false);
      setBatchAction('');

      // Mostrar mensagem de sucesso (opcional)
      console.log(response.data.message);

      // Forçar atualização da lista
      window.location.reload();
    } catch (error) {
      console.error('Erro ao atualizar tickets em lote:', error);
      // Aqui você pode adicionar uma notificação de erro para o usuário
    } finally {
      setBatchLoading(false);
    }
  };

  const handleCancelBatchAction = () => {
    setConfirmBatchModal(false);
    setBatchAction('');
  };

  // Callback para receber tickets selecionados do componente TicketsList
  const handleTicketSelection = (ticketIds) => {
    setSelectedTickets(ticketIds);
  };

  // Resetar seleções quando sair da visualização de meus tickets
  useEffect(() => {
    if (showAllTickets.current || userTickets === 'all' || (+userTickets !== +user.id)) {
      setSelectedTickets([]);
    }
  }, [showAllTickets.current, userTickets, user.id]);

  // Função para controlar accordion apenas pelo botão de filtro
  const handleToggleFilters = () => {
    setExpanded(expanded ? false : 'panel1');
  };

  // Não permitir que o accordion abra/feche clicando no summary
  const handleChangeAccordion = () => {
    // Função vazia - accordion só abre/fecha pelo botão
  };

  const handleChangeTabTicketLength = (value, status) => {
    if (status === 'open') {
      return setTicketsListOpenLength(value)
    }
    if (status === 'archived') {
      return setTicketsListArchivedLength(value)
    }
    if (status === 'pending') {
      return setTicketsListPendingLength(value)
    }
    if (status === 'closed') {
      return setTicketsListClosedLength(value)
    }
  }

  // CORRIGIDO: Função handleChange para manter consistência de tipos
  const handleChange = (event) => {
    const value = event.target.value;

    if (value === 'all') {
      showAllTickets.current = true;
      setUserTickets("all");
    } else if (value === user.id?.toString()) {
      setUserTickets(user.id?.toString());
      showAllTickets.current = false;
    } else {
      // Para seleção de outros usuários - manter como string para consistência
      setUserTickets(value.toString());
      showAllTickets.current = false;
    }
  };

  // ADICIONADO: Função para renderizar o valor selecionado no Select
  const renderSelectValue = (selected) => {
    if (selected === 'all') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          🌐 {i18n.t("tickets.buttons.showAll")}
        </Box>
      );
    } else if (selected === user.id?.toString()) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Avatar
            src={user.media}
            className={classes.selectedUserAvatar}
          >
            {user.name?.charAt(0)?.toUpperCase()}
          </Avatar>
          Meus atendimentos
        </Box>
      );
    } else {
      // Encontrar o usuário selecionado na lista
      const selectedUser = users?.find(usr => usr.id?.toString() === selected?.toString());
      if (selectedUser) {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar
              src={selectedUser.media}
              className={classes.selectedUserAvatar}
            >
              {selectedUser.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            {selectedUser.name}
          </Box>
        );
      }
      return 'Selecionar usuário';
    }
  };

  useEffect(() => {
    let isActive = true;
    let getAllUsers = false;
    (async () => {
      const { data } = await api.get("/users/", { params: { isActive, getAllUsers } });
      setUsers(data.users)
    })();
  }, [user])


  useEffect(() => {
    (async () => {
      const { data } = await api.get("/whatsapp/");
      setConnections(data);
      const ids = data.map((c) => c.id);

      const connectionIds = [...ids, 'no_connection'];
      setSelectedConnectionIds(connectionIds)
    })();
  }, [])

  // Buscar plantão atual da empresa e determinar períodos ativos agora.
  // pendingTicketsLogic é gerenciado pelo hook usePendingTicketsLogic — fonte única.
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings-company");
        const pow = data?.findPeriodOfWork;
        if (!pow) return;

        const now = new Date();
        const currentMin = now.getHours() * 60 + now.getMinutes();
        const active = [];

        for (const key of ['morning', 'afternoon', 'night']) {
          if (!pow[key]) continue;
          try {
            const { start, end } = JSON.parse(pow[key]);
            if (!start || !end || (start === '00:00' && end === '00:00')) continue;
            const [sh, sm] = start.split(':').map(Number);
            const [eh, em] = end.split(':').map(Number);
            const s = sh * 60 + sm;
            const e = eh * 60 + em;
            // Período normal (ex: 06:00-12:00) ou overnight (ex: 18:00-06:00)
            if (s < e ? (currentMin >= s && currentMin < e) : (currentMin >= s || currentMin < e)) {
              active.push(key);
            }
          } catch { }
        }

        setCompanyPeriods(active);
      } catch { }
    })();
  }, []);

  let searchTimeout;
  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setTab("open");
    } else {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 500);
  };

  // Busca do accordion — só dispara ao clicar em pesquisar ou Enter
  const handleAccordionSearchInput = (e) => {
    setAccordionSearchParam(e.target.value);
  };

  const handleAccordionSearchSubmit = () => {
    const term = accordionSearchParam.trim().toLowerCase();
    if (term === "") {
      setSearchParam("");
      setTab("open");
    } else {
      setSearchParam(term);
      setTab("search");
    }
  };

  const handleAccordionSearchClear = () => {
    setAccordionSearchParam("");
    setSearchParam("");
    setTab("open");
    if (accordionSearchInputRef.current) {
      accordionSearchInputRef.current.value = "";
    }
  };

  const handleAccordionSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAccordionSearchSubmit();
    }
  };

  const excludeMessage = () => {
    document.getElementById("searchTickets").value = "";
    setSearchParam("");
    setTab("open");
  };

  const handleChangeTab = (e, newValue) => {
    setAccordionSearchParam("");
    setSearchParam("");
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setAccordionSearchParam("");
    setSearchParam("");
    setTab("open");
    setTabOpen(newValue);
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  }

  // ADICIONADO: useEffect para debug do localStorage
  useEffect(() => {
    console.log('Estados atuais:', {
      viewTags,
      viewConnections,
      viewTagsLS: localStorage.getItem("viewTags"),
      viewConnectionsLS: localStorage.getItem("viewConnections")
    });
  }, [viewTags, viewConnections]);

  return (
    <Paper elevation={0} id="contentTicketsManager" variant="outlined" className={"ticketsWrapper"}>
      <CreateTicketModal
        open={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            id="openTab"
            value={"open"}
            icon={<AllInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            id="rescheduledTab"
            value={"rescheduled"}
            icon={<AccessAlarmsIcon />}
            label={i18n.t("tickets.tabs.rescheduled.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            id="closedTab"
            value={"closed"}
            icon={<LibraryAddCheckIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      <Divider />

      <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleChangeAccordion}
      >
        <AccordionSummary
          expandIcon={null}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          onClick={(e) => e.preventDefault()}
          sx={{
            padding: '0px',
            minHeight: '39px',
            '&.Mui-expanded': {
              minHeight: '39px',
            },
            '& .MuiAccordionSummary-content': {
              margin: 0,
            },
            '&.Mui-focusVisible': {
              backgroundColor: '#00000000 !important',
            },
            '& .MuiAccordionSummary-root': {
              padding: '0px !important',
            },
          }}

        >
          <Box className={classes.accordionSummaryContent}>
            <Box className={classes.searchContainer}>
              <Box className={classes.accordionSearchWrapper}>
                <SearchIcon className={classes.searchIcon} />
                <InputBase
                  className={classes.accordionSearchInput}
                  inputRef={accordionSearchInputRef}
                  placeholder="Nome, número, email ou contrato"
                  type="text"
                  value={accordionSearchParam}
                  onChange={handleAccordionSearchInput}
                  onKeyDown={handleAccordionSearchKeyDown}
                  onClick={(e) => e.stopPropagation()}
                />
                {accordionSearchParam && (
                  <>
                    <IconButton
                      size="small"
                      onClick={(e) => { e.stopPropagation(); handleAccordionSearchClear(); }}
                      sx={{ p: '4px', color: 'text.secondary', '&:hover': { color: 'error.main' } }}
                    >
                      <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{ mx: '4px', my: '4px' }} />
                    <IconButton
                      size="small"
                      onClick={(e) => { e.stopPropagation(); handleAccordionSearchSubmit(); }}
                      sx={{ p: '4px', color: 'primary.main' }}
                      title="Pesquisar"
                    >
                      <SearchSubmitIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                  </>
                )}
              </Box>

              <Box className={classes.actionButtons}>
                {/* Botões de ação em lote - aparecem apenas quando há tickets selecionados e estou visualizando meus tickets */}
                {selectedTickets.length > 0 && !showAllTickets.current && userTickets !== 'all' && (+userTickets === +user.id) && (
                  <>
                    <Tooltip title={`Mover ${selectedTickets.length} atendimento(s) para Aguardando`} placement="top">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleBatchAction('pending');
                        }}
                        sx={{
                          padding: '5px',
                          color: 'warning.main',
                          '&:hover': {
                            backgroundColor: 'warning.light',
                            color: 'warning.dark',
                          }
                        }}
                      >
                        <HourglassEmptyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title={`Mover ${selectedTickets.length} atendimento(s) para Resolvidos`} placement="top">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleBatchAction('closed');
                        }}
                        sx={{
                          padding: '5px',
                          color: 'success.main',
                          '&:hover': {
                            backgroundColor: 'success.light',
                            color: 'success.dark',
                          }
                        }}
                      >
                        <CheckCircleIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                      {selectedTickets.length} selecionado(s)
                    </Typography>
                  </>
                )}

                <Tooltip title={expanded ? "Ocultar Filtros" : "Mostrar Filtros"} placement="top">
                  <Checkbox
                    checked={expanded === 'panel1'}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleFilters();
                    }}
                    icon={<FilterListIcon fontSize="small" />}
                    checkedIcon={<FilterListIcon fontSize="small" />}
                    sx={{
                      padding: '5px',
                      color: expanded === 'panel1' ? 'primary.main' : 'action.active',
                      '&.Mui-checked': {
                        color: 'primary.main',
                      }
                    }}
                  />
                </Tooltip>

                <Tooltip title={viewTags ? "Ocultar Tags" : "Mostrar Tags"} placement="top">
                  <Checkbox
                    checked={viewTags}
                    onClick={handleToggleViewTags}
                    icon={<LocalOfferIcon fontSize="small" />}
                    checkedIcon={<LocalOfferIcon fontSize="small" />}
                    sx={{
                      padding: '5px',
                      color: viewTags ? 'primary.main' : 'action.active',
                      '&.Mui-checked': {
                        color: 'primary.main',
                      }
                    }}
                  />
                </Tooltip>

                <Tooltip title={viewConnections ? "Ocultar Conexões" : "Mostrar Conexões"} placement="top">
                  <Checkbox
                    checked={viewConnections}
                    onClick={handleToggleViewConnections}
                    icon={<SensorsOffIcon fontSize="small" />}
                    checkedIcon={<SensorsIcon fontSize="small" />}
                    sx={{
                      padding: '5px',
                      color: viewConnections ? 'primary.main' : 'action.active',
                      '&.Mui-checked': {
                        color: 'primary.main',
                      }
                    }}
                  />
                </Tooltip>
              </Box>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{
          borderTop: '1px solid rgba(0, 0, 0, 0.125)',
          padding: '5px',
        }}>
          <Grid container spacing={1} alignItems="center">

            <Grid item xs={12} sm={user.profile !== 'user' ? 6 : 12} md={user.profile !== 'user' ? 6 : 12}>
              <TicketsQueueSelect
                selectedQueueIds={selectedQueueIds}
                userQueues={user?.queues}
                onChange={(values) => setSelectedQueueIds(values)}
              />
            </Grid>

            <Grid item xs={12} sm={user.profile !== 'user' ? 6 : 12} md={user.profile !== 'user' ? 6 : 12}>
              <TicketsConnectionSelect
                selectedConnectionIds={selectedConnectionIds}
                userConnections={connections}
                onChange={(values) => setSelectedConnectionIds(values)}
              />
            </Grid>

            {(user.profile !== 'user') && (
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth size="small">
                  <InputLabel htmlFor="grouped-native-select">Visualizar</InputLabel>
                  <Select
                    id="grouped-native-select"
                    label="Grouping"
                    value={userTickets || user.id?.toString()}
                    onChange={handleChange}
                    renderValue={renderSelectValue}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 600,
                          width: 350,
                          borderRadius: '8px',
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                          marginTop: '4px',
                        },
                        sx: {
                          '& .MuiList-root': {
                            padding: 0,
                          }
                        }
                      },
                      autoFocus: false,
                      disableAutoFocusItem: true,
                    }}
                  >
                    <ListSubheader sx={{
                      lineHeight: '25px',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'text.secondary',
                      padding: '8px 16px',
                      backgroundColor: 'transparent'
                    }}>
                      Filtros
                    </ListSubheader>

                    <MenuItem
                      value={user.id?.toString()}
                      sx={{ padding: '8px 16px', fontSize: '14px' }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                          src={user.media}
                          className={classes.selectedUserAvatar}
                        >
                          {user.name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        Meus atendimentos
                      </Box>
                    </MenuItem>

                    <MenuItem
                      value={'all'}
                      sx={{ padding: '8px 16px', fontSize: '14px' }}
                    >
                      🌐 {i18n.t("tickets.buttons.showAll")}
                    </MenuItem>

                    <ListSubheader sx={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'text.secondary',
                      padding: '8px 16px',
                      backgroundColor: 'transparent',
                      borderTop: '1px solid',
                      borderTopColor: 'divider',
                      marginTop: '4px',
                      paddingTop: '12px',
                      lineHeight: '25px'
                    }}>
                      Categoria
                    </ListSubheader>

                    <Box
                      sx={{ display: 'flex', gap: 0.5, px: 2, pb: 1, flexWrap: 'wrap' }}
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => e.stopPropagation()}
                    >
                      {[
                        { key: 'all', label: 'Todos' },
                        { key: 'active', label: `Ativos (${statusCounts.active})` },
                        { key: 'dayoff', label: `Em folga (${statusCounts.dayoff})` },
                        { key: 'offshift', label: `Fora do plantão (${statusCounts.offshift})` },
                      ].map(opt => (
                        <Chip
                          key={opt.key}
                          label={opt.label}
                          size="small"
                          variant={statusFilter === opt.key ? 'filled' : 'outlined'}
                          color={statusFilter === opt.key ? 'primary' : 'default'}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setStatusFilter(opt.key);
                          }}
                          sx={{ cursor: 'pointer', fontSize: '11px', height: 24 }}
                        />
                      ))}
                    </Box>

                    <ListSubheader sx={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'text.secondary',
                      padding: '8px 16px',
                      backgroundColor: 'transparent',
                      borderTop: '1px solid',
                      borderTopColor: 'divider',
                      marginTop: '4px',
                      paddingTop: '12px',
                      lineHeight: '25px'
                    }}>
                      Usuários
                    </ListSubheader>

                    <Box sx={{
                      position: 'sticky',
                      top: 0,
                      backgroundColor: 'background.paper',
                      zIndex: 1000,
                      padding: '12px',
                      borderBottom: '1px solid',
                      borderBottomColor: 'divider',
                    }}>
                      <InputBase
                        placeholder="Buscar usuário..."
                        value={userSearchTerm}
                        onChange={handleUserSearchChange}
                        onKeyDown={handleUserSearchKeyDown}
                        onClick={handleUserSearchClick}
                        startAdornment={
                          <SearchIcon sx={{
                            mr: 1,
                            fontSize: 20,
                            color: 'text.secondary'
                          }} />
                        }
                        sx={{
                          width: '100%',
                          padding: '8px 12px',
                          backgroundColor: theme => theme.palette.mode === 'dark'
                            ? 'rgba(255, 255, 255, 0.05)'
                            : '#f8f9fa',
                          borderRadius: '6px',
                          border: 'none',
                          fontSize: '14px',
                          '& input': {
                            padding: 0,
                            '&::placeholder': {
                              color: 'text.secondary',
                              opacity: 0.7,
                            }
                          },
                          '&:focus-within': {
                            backgroundColor: theme => theme.palette.mode === 'dark'
                              ? 'rgba(255, 255, 255, 0.08)'
                              : '#ffffff',
                            outline: theme => `2px solid ${theme.palette.primary.main}`,
                            outlineOffset: '-2px',
                          }
                        }}
                      />
                      {userSearchTerm && (
                        <Typography variant="caption" sx={{
                          display: 'block',
                          mt: 1,
                          color: 'text.secondary',
                          fontSize: '12px'
                        }}>
                          {filteredUsers.length} resultado{filteredUsers.length !== 1 ? 's' : ''}
                        </Typography>
                      )}
                    </Box>

                    {(() => {
                      if (filteredUsers.length === 0) {
                        return (
                          <MenuItem disabled sx={{
                            padding: '20px',
                            textAlign: 'center',
                            color: 'text.secondary',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            display: 'flex'
                          }}>
                            <SearchIcon sx={{ fontSize: 24, opacity: 0.5, mb: 1 }} />
                            <Typography variant="body2">
                              {userSearchTerm || statusFilter !== 'all'
                                ? 'Nenhum usuário encontrado'
                                : 'Nenhum usuário disponível'}
                            </Typography>
                          </MenuItem>
                        );
                      }

                      return filteredUsers.map((usr) => {
                        const isSelected = userTickets?.toString() === usr.id?.toString();
                        const presenceColor = usr.status === 1 ? '#44b700' : usr.status === 2 ? '#ffc800' : '#ff4545';
                        return (
                          <MenuItem
                            key={`user-${usr.id}`}
                            value={usr.id?.toString()}
                            selected={isSelected}
                            sx={{
                              padding: '10px 16px',
                              fontSize: '14px',
                              borderLeft: isSelected ? '3px solid' : '3px solid transparent',
                              borderLeftColor: 'primary.main',
                              backgroundColor: isSelected ? 'primary.main' : 'transparent',
                              color: isSelected ? 'primary.contrastText' : 'text.primary',
                              '&:hover': {
                                backgroundColor: isSelected ? 'primary.dark' : 'action.hover',
                              },
                              '&.Mui-selected': {
                                backgroundColor: 'primary.main',
                                color: 'primary.contrastText',
                                '&:hover': {
                                  backgroundColor: 'primary.dark',
                                }
                              }
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                              <Box sx={{ position: 'relative', display: 'flex' }}>
                                <Avatar
                                  src={usr.media}
                                  className={classes.userAvatar}
                                >
                                  {usr.name?.charAt(0)?.toUpperCase()}
                                </Avatar>
                                <Box sx={{
                                  position: 'absolute',
                                  bottom: -1,
                                  right: -1,
                                  width: 10,
                                  height: 10,
                                  borderRadius: '50%',
                                  bgcolor: presenceColor,
                                  border: '2px solid',
                                  borderColor: 'background.paper',
                                }} />
                              </Box>
                              <Typography variant="body2" sx={{
                                color: 'inherit',
                                fontWeight: 400
                              }}>
                                {usr.name}
                              </Typography>
                            </Box>
                          </MenuItem>
                        );
                      });
                    })()}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Divider />
      <Button size="large" id="clickArchive" onClick={() => { setAccordionSearchParam(""); setSearchParam(""); setTab(tab == 'archived' ? 'open' : 'archived'); }}>
        <Box sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography sx={{ display: 'flex', flexShrink: 0 }}>
            {tab == 'archived' && tab !== 'open' ? <ModeCommentIcon fontSize="small" /> : <InventoryIcon fontSize="small" />}
          </Typography>
          <Badge max={999} color="primary" badgeContent={ticketsListArchivedLength}>
            <Typography sx={{ color: 'text.secondary' }}>
              {tab == 'archived' && tab !== 'open' ? <>Voltar para conversas</> : <>Arquivados</>}
            </Typography>
          </Badge>
          {tab == 'archived' && <KeyboardArrowLeftIcon />}
          {tab !== 'archived' && <KeyboardArrowRightIcon />}
        </Box>
      </Button>
      <Divider />

      <TabPanel value={tab} name="open" className={"ticketsWrapper"}>
        <Paper elevation={0} square className={classes.tabsHeader}>
          <Tabs
            value={tabOpen}
            onChange={handleChangeTabOpen}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            aria-label="icon label tabs example"
          >
            <Tab
              id="openTickets"
              value={"open"}
              label={<Badge badgeContent={ticketsListOpenLength} max={999} color="primary">{i18n.t("tickets.tabs.open.open")}</Badge>}
              classes={{ root: classes.tab }}
            />
            <Tab
              id="pendingTickets"
              value={"pending"}
              label={<Badge badgeContent={ticketsListPendingLength} max={999} color="primary">{i18n.t("tickets.tabs.open.pending")}</Badge>}
              classes={{ root: classes.tab }}
            />
          </Tabs>
        </Paper>
        <Box
          component="div"
          name="open"
          className={tabOpen === 'open' ? classes.ticketsOpenWrapper : classes.isTabClosed}
        >
          <TicketsList
            noQueue={user.noQueue}
            companyId={user.companyId}
            viewTags={viewTags}
            viewConnections={viewConnections}
            status="open"
            showAll={showAllTickets.current}
            selectedQueueIds={selectedQueueIds}
            selectedConnectionIds={selectedConnectionIds}
            userTickets={userTickets}
            reloadCount={(count) => handleChangeTabTicketLength(count, 'open')}
            onTicketSelection={handleTicketSelection}
            selectedTickets={selectedTickets}
          />
        </Box>
        <Box
          component="div"
          name="pending"
          className={tabOpen === 'pending' ? classes.ticketsOpenWrapper : classes.isTabClosed}
        >
          {canOverridePendingView && pendingViewOverride && (
            <Box sx={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: 1, px: 1.5, py: 0.75, mx: 1, mt: 1,
              border: 1, borderColor: 'divider', borderRadius: 1,
              bgcolor: 'background.paper',
            }}>
              <Typography sx={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, color: 'text.secondary' }}>
                Visualização local · {pendingViewOverride === 'list' ? 'Lista' : 'Próximo da fila'}
              </Typography>
              <Button
                size="small"
                onClick={() => setPendingViewOverride(null)}
                sx={{ textTransform: 'none', fontSize: 11, fontWeight: 500 }}
              >
                Restaurar padrão
              </Button>
            </Box>
          )}
          {effectivePendingLogic === 'next' ? (
            <PendingTicketsNextMode
              companyId={user.companyId}
              showAll={showAllTickets.current}
              selectedQueueIds={selectedQueueIds}
              reloadCount={(count) => handleChangeTabTicketLength(count, 'pending')}
              canSwitchToList={canOverridePendingView}
              onSwitchToList={() => setPendingViewOverride('list')}
            />
          ) : (
            <TicketsList
              noQueue={user.noQueue}
              companyId={user.companyId}
              viewTags={viewTags}
              viewConnections={viewConnections}
              status="pending"
              showAll={showAllTickets.current}
              selectedQueueIds={selectedQueueIds}
              selectedConnectionIds={selectedConnectionIds}
              userTickets={userTickets}
              reloadCount={(count) => handleChangeTabTicketLength(count, 'pending')}
              onTicketSelection={handleTicketSelection}
              selectedTickets={selectedTickets}
            />
          )}
        </Box>
      </TabPanel>
      <TabPanel value={tab} name="archived" className={"ticketsWrapper"}>
        <Box
          component="div"
          name="pending"
          className={classes.ticketsOpenWrapper}
        >
          <TicketsList
            noQueue={user.noQueue}
            companyId={user.companyId}
            viewTags={viewTags}
            viewConnections={viewConnections}
            status="archived"
            showAll={showAllTickets.current}
            selectedQueueIds={selectedQueueIds}
            selectedConnectionIds={selectedConnectionIds}
            userTickets={userTickets}
            reloadCount={(count) => handleChangeTabTicketLength(count, 'archived')}
          />
        </Box>
      </TabPanel>
      <TabPanel value={tab} name="rescheduled" className={"ticketsWrapper"}>
        <TicketsList
          noQueue={user.noQueue}
          companyId={user.companyId}
          viewTags={viewTags}
          viewConnections={viewConnections}
          status="pending"
          isRescheduled={true}
          showAll={showAllTickets.current}
          selectedQueueIds={selectedQueueIds}
          selectedConnectionIds={selectedConnectionIds}
          userTickets={userTickets}
          reloadCount={(count) => { }}
        />
      </TabPanel>
      <TabPanel value={tab} name="closed" className={"ticketsWrapper"}>
        <TicketsList
          noQueue={user.noQueue}
          companyId={user.companyId}
          viewTags={viewTags}
          viewConnections={viewConnections}
          status="closed"
          showAll={showAllTickets.current}
          userTickets={userTickets}
          selectedQueueIds={selectedQueueIds}
          selectedConnectionIds={selectedConnectionIds}
          reloadCount={(count) => { }}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={"ticketsWrapper"}>
        <TicketsList
          noQueue={user.noQueue}
          companyId={user.companyId}
          viewTags={viewTags}
          viewConnections={viewConnections}
          searchParam={searchParam}
          showAll={true}
          userTickets={""}
          selectedQueueIds={selectedQueueIds}
          selectedConnectionIds={selectedConnectionIds}
          reloadCount={(count) => { }}
        />
      </TabPanel>
      <Box sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '5px'
      }}>
        <Tooltip title="Novo atendimento">
          <Button
            sx={{
              borderRadius: '35px',
              minWidth: '35px',
              padding: '5px'
            }}
            variant="contained"
            color="primary"
            onClick={() => setNewTicketModalOpen(true)}
          >
            <AddIcon />
          </Button>
        </Tooltip>
      </Box>

      {/* Modal de confirmação para ações em lote */}
      <Dialog
        open={confirmBatchModal}
        onClose={handleCancelBatchAction}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {batchAction === 'pending' ? 'Mover para Aguardando' : 'Mover para Resolvidos'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Você está prestes a mover <strong>{selectedTickets.length}</strong> atendimento(s) para{' '}
            <strong>{batchAction === 'pending' ? 'Aguardando' : 'Resolvidos'}</strong>.
          </DialogContentText>
          <DialogContentText sx={{ mt: 2, fontWeight: 'bold', color: 'primary.main' }}>
            Apenas os seus atendimentos serão movidos.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelBatchAction} disabled={batchLoading}>
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmBatchAction}
            variant="contained"
            color={batchAction === 'pending' ? 'warning' : 'success'}
            disabled={batchLoading}
          >
            {batchLoading ? 'Processando...' : 'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper >
  );
};

export default TicketsManager;